import InputFileForm               from '../components/Form/InputFileFormContainer';
import InputFileTableContainer     from '../components/Table/InputFileTableContainer';
import InputFileDateFilter         from '../components/Filters/InputFileDateFilter';
import DemandsTableModalContainer  from '../components/Modals/DemandsTableModalContainer.js';
import InputFilePageHorizonFilter  from '../components/Filters/InputFilePageHorizonFilter';

import { UseInputFile }            from '../contexts/InputFilePageContext';
import { useUser }                 from '../contexts/UserContext.js';
import { findPermission }          from '../utils/UserPermissionUtils.js';
import { useNavigate }             from 'react-router-dom';
import { useEffect }               from 'react';
import '../styles/main.css';


function InputFilePage() {
    

    const { handleModalFileOpen }   = UseInputFile();
    const { userData }              = useUser()

    const navigate = useNavigate();

    useEffect(() => {
        
        if (!userData?.permissions) return;
    
        const hasPermission = findPermission(userData, "Acesso à Pagina de Demandas");
        
        if (!hasPermission) {
          navigate("/home");
        }
    
      }, [userData, navigate]);
   
    return (

        <div className="pg-content">
            
            <InputFileForm />
            
            <header>

                <h1 className="mb-5">
                    Demandas
                </h1>

                <section className="w-full bg-neutro borda-cinza rounded-[7px] p-[1rem] flex justify-between gap-[10px]">
                    
                    <InputFileDateFilter />

                        {findPermission(userData, "Enviar Demandas") && (
                            <button 
                                className=" flex mr-15px ml-auto btn bg-azul-profundo-m hover:bg-azul-profundo-e z-10 h-10 items-center"
                                onClick={handleModalFileOpen}
                            >
                                Inserir Demandas
                            </button>
                        )}

                </section>
                
                <InputFilePageHorizonFilter/>
                
            </header>
            
            <InputFileTableContainer /> 
            <DemandsTableModalContainer/>
          
            
            
        </div>
    );
}

export default InputFilePage;